/**
 * Функция сравнения двух списков.
 * @param arr1 - Массив №1.
 * @param arr2 - Массив №2.
 */
export function areArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }

    let sortedArr1 = [...arr1].sort();
    let sortedArr2 = [...arr2].sort();

    return sortedArr1.every((value, index) => value === sortedArr2[index]);
}

/**
 * Функция для добавления в массив №1 элементов из массива №2, которые отсутствуют в массиве №1.
 * @param initial - массив изначальных элементов.
 * @param incoming - массив элементов, который должны быть добавлены.
 * @param key - ключи для сравнения, ЕСЛИ СПИСОК элементов содержит объекты. По умолчанию NULL.
 */
export function addMissingElements (initial, incoming, key = null) {
    try {
        if (!incoming || !initial) return;
        incoming.forEach(item => {
            // Проверяем, есть ли элемент в начальном массиве
            let exists;
            if (key) {
                exists = initial.some(initialItem => initialItem[key] === item[key]);
            } else {
                exists = initial.some(initialItem => initialItem === item);
            }
            if (!exists) {
                initial.push(item);
            }
        });
    } catch (e) {
        console.log("e");
        initial = [];
    }
}

// Функция для типизации айди number => string.
// TODO: Удалить функцию и все места где используется, после изменения айдишников на беке. task 1873.
// Принимает либо «голый» массив (старый формат), либо пагинированный { items: [...] }
// (новый формат, в который бэк постепенно мигрирует endpoint'ы).
export function convertIdsToString(data) {
    const list = Array.isArray(data) ? data : (data && Array.isArray(data.items) ? data.items : []);
    return list.map(item => ({
        ...item,
        id: String(item.id)
    }));
}